import { validateTvEnv } from '@streambase/config/tv';
import BRAND_CONFIGS from './brand-configs.generated';
const CONFIGS: Record<string, (typeof BRAND_CONFIGS)[keyof typeof BRAND_CONFIGS]> = BRAND_CONFIGS;

const tvEnv = validateTvEnv();
const envBrand = tvEnv.APP_CLIENT.toLowerCase();

const allConfigs = Object.values(BRAND_CONFIGS);
const uniqueConfigs = allConfigs.filter(
  (c, i, arr) => arr.findIndex((x) => x.client === c.client) === i,
);
const defaultConfig = uniqueConfigs[0];

export const resolveBrand = (brand: string | undefined) => {
  if (!brand) return defaultConfig.client;
  const config = CONFIGS[brand.toLowerCase()];
  if (config) return config.client;
  return defaultConfig.client;
};

export const CURRENT_BRAND = resolveBrand(envBrand);
export const CURRENT_CONFIG = CONFIGS[CURRENT_BRAND];

export default CURRENT_CONFIG;
